import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Cover from '../components/cover/cover'

import cover from "../images/about-cover-alt.jpg"

const AboutPage = () => (
  <Layout>
    <SEO title="We Clothe Them - What We Do" />
    <Cover
      image={cover}
      title={`What We Do`}
      paragraph={`We Clothe Them is an NGO seeking to empower the less privileged by
      giving them access to one of the basic needs of survival - clothing.`}
      button={``}
    />
    <section className={``}>
      <div className={`content-sm`}>
        <h6 className={`letter-spaced-heading`}>What We Do</h6>
        <h2>About the Initiative</h2>
        <p>
          In 2016, More than 1,600 people died due to extreme weather conditions
          across the country. Winter is in fact the second major reason for
          deaths in India after lightening, according to a government
          statistics. While many major economies of the world recognize Right to
          Clothing as a fundamental right, India still doesn't. We keep hoping
          and waiting for tickle down effect to improve the lives of those below
          the poverty line. We all remain a victim of the bystander effect:
          hoping, waiting, doing nothing.
        </p>

        <p>
          We Clothe Them is an endeavour to do something about it because well
          you and I easily can. Because sometimes it's not about how many others
          are doing something about it, it is about what are you doing about it.
          And sometimes all that is needed to empower a person is the simple
          gesture of reaching out to your wardrobe and taking out a cloth you
          don't wear anymore for whatever reason and gifting it to someone who
          could really do with it. Let's clothe them because all of us together
          can.
        </p>

        <p>
          It is an attempt to gift comfort, warmth, protection, hygiene and
          hope. We Clothe Them because together we can.
        </p>
      </div>
    </section>
    <section className={`dark sm`}>
      <div className={`content-md`}>
        <h6 className={`letter-spaced-heading center`}>
          A Social Index Survey
        </h6>
        <h2 className={`center`}>The Current Scenario</h2>
        <p className={`center`}>
          We conducted a social index survey to understand the relevance of our
          initiative. Here are some insights from the survey.
        </p>
        <div
          className={`flex`}
          style={{ flexWrap: `wrap`, justifyContent: `center` }}
        >
          <div className={`stat-tile`}>
            <div className={`content-md`}>
              <h1>87%</h1>
              <p>of the peoeple have donated clothes at some point of time in their life</p>
            </div>
          </div>
          <div className={`stat-tile`}>
            <div className={`content-md`}>
              <h1>94%</h1>
              <p>of the people would like to donate clothes for a good cause</p>
            </div>
          </div>
          <div className={`stat-tile`}>
            <div className={`content-md`}>
              <h1>67%</h1>
              <p>of the people have clothes they haven't worn for more than one year</p>
            </div>
          </div>
          <div className={`stat-tile`}>
            <div className={`content-md`}>
              <h1>53%</h1>
              <p>of the people have clothes they want to donate but don't know where to donate them</p>
            </div>
          </div>
          <div className={`stat-tile`}>
            <div className={`content-md`}>
              <h1>86%</h1>
              <p>of the people would like to be a part of the initiative that helps to clothe people</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className={`grey`}>
      <div className={`content-sm`}>
        <h6 className={`letter-spaced-heading`}>Motivation</h6>
        <h2>Why Clothing?</h2>
        <p>
          You would wonder why another NGO doing the same old thing for the same
          old cause. But the truth is, there may be many, but there aren't
          enough. And can there ever be too much of gifting warmth, protection
          and hope?
        </p>

        <p>
          Even now, on cold mornings, between my walk from home to the metro
          station to catch the 8AM metro to college, I find shivering bodies of
          young kids collecting rubbish off the pavements in the fogy mist of
          Delhi's January winters. I find ladies getting ready for another hard
          day of work making do with no, or in the rarest cases, a thin shawl. I
          find babies naked on the roadside, their treat being who would get
          that tiny piece of blanket that night. On traffic signals, I am again
          greeted with such gory sights. While we are wondering if to go to Zara
          to get that jumper or just grab another T-shirt from Tommy because
          well you are just plain bored of your existing wardrobe or need
          something to kill time, there are so many who don't get to change into
          a fresh washed set of clothes every day. While we have cupboards full
          of clothes we don't even wear anymore, there are many across the globe
          who don't get enough clothe to envelope their bodies. And the
          unfairness of it all moves us but perhaps only for a brief while. We
          come across such sights and read about unequal distribution of
          resources umpteenth times in sociology and economics classes but we
          don't do anything about it.
        </p>
      </div>
    </section>
  </Layout>
)

export default AboutPage